enum ProjectConfigureStepEnum {
  General = 1,
  Configuration = 2,
  AddOns = 3,
}

export default ProjectConfigureStepEnum
